.dialog {
  top: 32px;
  transform: translateX(-50%);
  margin: 0;
  min-height: 200px;
}

.dialogContent {
  display: flex;
  flex-direction: column;
}
